import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { RegistrationLayout } from "../../../RegistrationLayout/RegistrationLayout";
import { RegistrationSetupNavbar } from "../../../RegistrationLayout/RegistrationSetupNavbar";
import RegistrationSetupWrapper from "../../RegistrationSetup.style";
import {
  REGISTRATION_SETUP_STEP_META,
  REGISTRATION_SETUP_TOTAL_STEPS,
  appleUrl,
  googleUrl,
} from "../../../../helper/constants";
import AppStoreImage from "../../../../assets/images/AppStoreBadge.png";
import GooglePlayImage from "../../../../assets/images/GooglePlayBadge.png";
import { getRegistrationData } from "../../registrationSetupStorage";
import { trackRegistrationCompleted } from "../../../../helper/registrationAnalytics";

const REGISTRATION_COMPLETED_FLAG = "husk_ga_registration_completed";

const DOWNLOAD_STEP = REGISTRATION_SETUP_STEP_META.APP_DOWNLOAD;

const RegistrationAppDownload = ({ history }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById("root");
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    const prevRootHeight = root?.style.height ?? "";

    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    if (root) {
      root.style.height = "100vh";
      root.style.height = "100dvh";
    }

    const data = getRegistrationData();
    if (!data.bookedAppointment) {
      history.replace("/register/account/appointments");
    } else if (!sessionStorage.getItem(REGISTRATION_COMPLETED_FLAG)) {
      trackRegistrationCompleted();
      sessionStorage.setItem(REGISTRATION_COMPLETED_FLAG, "1");
    }

    return () => {
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
      if (root) {
        root.style.height = prevRootHeight;
      }
    };
  }, [history]);

  const handleAlreadyHaveApp = () => {
    message.info(t("NUTRITION_CALENDAR_BTN_FALLBACK"));
  };

  const handleDone = () => {
    history.replace("/register/account/all-set");
  };

  return (
    <RegistrationSetupWrapper>
      <RegistrationLayout
        containScroll
        header={
          <RegistrationSetupNavbar
            stepMeta={DOWNLOAD_STEP}
            totalSteps={REGISTRATION_SETUP_TOTAL_STEPS}
            showBack={false}
          />
        }
      >
        <div className="scroll-body">
          <div className="content-card content-card-download">
            <div className="content-card-scroll">
              <div className="app-dl-hero">
                <div className="app-dl-icon" aria-hidden>
                  <svg
                    width="44"
                    height="44"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#2d3f52"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18z" />
                    <path d="M12 8v4l3 3" />
                    <path d="M7.5 3.5c-1 1.5-1.5 3.5-1.5 5" />
                    <path d="M16.5 3.5c1 1.5 1.5 3.5 1.5 5" />
                  </svg>
                </div>
                <h2 className="app-dl-title">
                  {t("NUTRITION_APPPROMO_LBL_TITLE")}
                </h2>
              </div>

              <div className="store-btns app-icon">
                <img
                  className="cursor-pointer"
                  src={AppStoreImage}
                  alt={t("NUTRITION_APPDOWNLOAD_ALT_APP_STORE")}
                  onClick={() => window.open(appleUrl)}
                />
                <img
                  className="cursor-pointer"
                  src={GooglePlayImage}
                  alt={t("NUTRITION_APPDOWNLOAD_ALT_GOOGLE_PLAY")}
                  onClick={() => window.open(googleUrl)}
                />
              </div>

              <div className="app-dl-or">{t("NUTRITION_COMMON_LBL_OR_SEPARATOR")}</div>
              <div className="app-dl-already-wrap">
                <button
                  type="button"
                  className="app-already-btn"
                  onClick={handleAlreadyHaveApp}
                >
                  {t("NUTRITION_APPPROMO_BTN_HAVE_APP")}
                </button>
              </div>

              <div className="divider" style={{ marginTop: 28 }} />

              <div className="app-dl-done-wrap">
                <button type="button" className="btn-primary app-dl-done-btn" onClick={handleDone}>
                  {t("CALANDLY_WEB_BTN_DONE")} →
                </button>
              </div>
            </div>
          </div>
        </div>
      </RegistrationLayout>
    </RegistrationSetupWrapper>
  );
};

export default withRouter(RegistrationAppDownload);
